export interface SalatiToneDetailsDto
{
    getClientTxnId(): string;
    getChannelId(): string;
    getServiceId(): string;
    getActivityId(): string;
    getLanguage(): string;
    
    getServiceName():string;
    getToneId():string;
    getToneName():string;
    getTonePath():string;
}

export class SalatiToneDetailsDtoImpl implements SalatiToneDetailsDto
{
    private clientTxnId: string;
    private channelId: string;
    private serviceId: string;
    private activityId: string;
    private language: string;

    private serviceName: string;
    private toneId: string;
    private toneName: string;
    private tonePath: string;

    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    getClientTxnId(): string 
    {
        return this.clientTxnId;
    } 

    setServiceId(serviceId: string)
    {
        this.serviceId = serviceId;
    }
    getServiceId(): string 
    {
        return this.serviceId;
    } 

    setActivityId(activityId: string)
    {
        this.activityId = activityId;
    }
    getActivityId(): string 
    {
        return this.activityId;
    } 

    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    }
    getChannelId(): string 
    {
        return this.channelId;
    } 

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }
    
    setServiceName(serviceName: string)
    {
        this.serviceName = serviceName;
    }
    getServiceName(): string 
    {
        return this.serviceName;
    }

    setToneId(toneId: string)
    {
        this.toneId = toneId;
    }
    getToneId(): string 
    {
        return this.toneId;
    }

    setToneName(toneName: string)
    {
        this.toneName = toneName;
    }
    getToneName(): string 
    {
        return this.toneName;
    }

    setTonePath(tonePath: string)
    {
        this.tonePath = tonePath;
    }
    getTonePath(): string 
    {
        return this.tonePath;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/salatitonedetails/salatitonedetailsdto.ts